module.exports = __webpack_public_path__ + "img/antes_despues_99.b2fd58fa.png";